import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { Select2WrapperComponent } from '@components/select2-wrapper/select2-wrapper.component';
import { HelperService } from '@core/helper/helper.service';
import { DocumentTypeItem } from '@core/interface/document-type';
import { DocumentItem } from '@core/interface/employee-document';
import { environment } from '@environment/environment';
import {
  NgbPaginationModule,
  NgbActiveModal,
  NgbDatepickerModule,
  NgbCalendar,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-add-document',
  imports: [
    TranslatePipe,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbPaginationModule,
    Select2WrapperComponent,
    NgbDatepickerModule,
  ],
  templateUrl: './add-document.component.html',
  styles: ``,
})
export class AddDocumentComponent {
  activeModal = inject(NgbActiveModal);
  private formBuilder = inject(FormBuilder);
  private helperService = inject(HelperService);
  calendar = inject(NgbCalendar);
  @Input() document!: DocumentItem;
  validationform!: FormGroup;
  submit!: boolean;
  @Input() userId!: number;
  @Input() documentTypes: DocumentTypeItem[] = [];
  selectedCategory: string = '';
  isCategoryOthers: boolean = false;
  todaysDate = this.calendar.getToday();
  documentLoading: boolean = false;
  ngOnInit(): void {
    let custom_name = '';
    if (this.document && this.document?.document_id.toString() == '1') {
      custom_name = this.document?.name;
    }
    this.validationform = this.formBuilder.group({
      id: [this.document ? this.document?.id : ''],
      user_id: [this.userId ? this.userId : ''],
      document_type_id: [
        this.document ? this.document?.document_id : '',
        Validators.required,
      ],
      custom_name: [custom_name],
      attachments: [[] as File[]],
      expiry_date: [
        this.document?.expiry_date
          ? this.helperService.getNgbDatefromDate(this.document?.expiry_date)
          : null,
      ],
    });

    // this.selectedCategory
    this.form['document_type_id'].valueChanges.subscribe((val) => {
      if (val.toString() == '1') {
        this.isCategoryOthers = true;
        this.form['custom_name'].setValidators(Validators.required);
      } else {
        this.isCategoryOthers = false;
        this.form['custom_name'].clearValidators();
        this.form['custom_name'].setValue('');
      }
      this.form['custom_name'].updateValueAndValidity({ emitEvent: false });
    });

    if (this.document && this.document?.id.toString() !== '') {
      if (this.document?.attachment instanceof File) {
        this.attachments.setValue([this.document?.attachment as File]);
      } else {
        this.documentLoading = true;
        this.helperService
          .fetchFileFromUrl(
            environment.employee_attachment_url(
              this.document.attachment as string
            ),
            this.document.file_name
          )
          .then((file) => {
            this.documentLoading = false;
            this.attachments.setValue([file]);
          })
          .catch(() => {
            this.documentLoading = false;
          });
      }

      this.validationform.addControl(
        'flatDocumentIndex',
        new FormControl(this.document?.flatDocumentIndex)
      );
      this.validationform.addControl(
        'attachmentIndex',
        new FormControl(this.document?.attachmentIndex)
      );
    }
  }

  get form() {
    return this.validationform.controls;
  }
  validSubmit() {
    this.submit = true;
    this.validationform.markAllAsTouched();
    if (this.validationform.valid) {
      const data = this.validationform.value;
      data.attachments = [...data.attachments];
      if (data.expiry_date) {
        data.expiry_date = this.helperService
          .convertNgbDatetoMoment(data.expiry_date)
          ?.format('YYYY-MM-DD');
      }

      this.activeModal.close({
        ...this.validationform.value,
      });
    }
  }

  getFormControl(field: string) {
    return this.validationform.get(field) as FormControl;
  }
  onDocumentChange(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const files = input.files;
      this.attachments.setValue(files);
      this.attachments.markAsTouched();
    }
  }

  get attachments() {
    return this.validationform.get('attachments') as FormControl;
  }
  get fileLabel() {
    if (this.documentLoading) {
      return 'Loading...';
    }
    switch (this.attachments.value.length) {
      case 0:
        return 'No file chosen';
      case 1:
        return this.attachments.value[0].name;
      default:
        return `${this.attachments.value.length} files selected`;
    }
  }

  getDocumentTypeName(id: number) {
    const docType = this.documentTypes.find((doc) => doc.id === id);
    return docType ? docType.name : '';
  }
}
